import React from "react";
import Header from "../home-page/home-comps/Header";
import "./publicPageNavigation.css";

/**
 * Public marketing / informational pages without an existing Header render.
 * Pages that already include <Header /> should not be wrapped here: Header
 * itself supports desktop and mobile and duplicate headers would be confusing.
 */
export default function PublicPageNavigation({ children }) {
  return (
    <>
      <div className="publicPageNavigationHolder">
        <Header />
      </div>
      {children}
    </>
  );
}
